import React, { useContext, useEffect, useRef, useState } from "react";
import swal from "sweetalert";
import { Link } from "react-router-dom";
import { Button, Form,  Tab } from "react-bootstrap";
import Select from "react-select";
import { Authorblogmodal } from "./Modal";
import { AiOutlineClose } from "react-icons/ai";
import { GlobalContext } from "../Context/GlobalState";
import Editblogeditor from "./Editblogeditor";
import { BASE_URL_API_BLOG } from "../Utils/Constant";
import { apibasicauth } from "../Utils/Credentials";
const getCustomStyles = () => ({
  control: (provided) => ({
    ...provided,
    backgroundColor: "white",
    color: "black",
    borderColor: "#ced4da",
    boxShadow: "none",
    // width: "10rem",
  }),
  menu: (provided) => ({
    ...provided,
    backgroundColor: "white",
    color: "black",
  }),
  option: (provided, state) => ({
    ...provided,
    color: "black",
    backgroundColor: state.isFocused ? "#f8f9fa" : "white",
  }),
  singleValue: (provided) => ({
    ...provided,
    color: "black",
  }),
  dropdownIndicator: (provided) => ({
    ...provided,
    color: "black",
  }),
  indicatorSeparator: (provided) => ({
    ...provided,
    backgroundColor: "#ced4da",
  }),
});
const Editblogs = () => {
  const { password, username } = apibasicauth;
  const base64Credentials =
    typeof window === "undefined"
      ? Buffer.from(`${username}:${password}`).toString("base64")
      : btoa(`${username}:${password}`);
  const editorRef = useRef(null);
  const [submittedContent, setSubmittedContent] = useState("");
  const [loading, setLoading] = useState(false);
  const Editblogid = JSON.parse(sessionStorage.getItem("Editblogid"));
  console.log(Editblogid.slug);
  const [blocks, setBlocks] = useState([]);
  const GetProductBlogBySlug = async () => {
    setLoading(true);
    try {
      const myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");

      const requestOptions = {
        method: "POST",
        headers: {
          Authorization: `Basic ${base64Credentials}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ slug: Editblogid.slug }),
        redirect: "follow",
      };

      const res = await fetch(
        `${BASE_URL_API_BLOG}/GetProductBlogBySlug`,
        requestOptions
      );
      const data = await res.json();
      console.log("Geteditloadblog response:", data);

      if (data.status === "0" && data.data.length > 0) {
        const blog = data.data[0];
        setFormState({
          title: blog.title || "",
          slug: blog.slug || "",
          excerpt: blog.excerpt || "",
          featuredImage: blog.image_url || "",
          imgtitle: blog.image_title || "",
          alt: blog.image_desc || "",
          imgdesc: blog.image_desc || "",
        });
        if (blog.keyword) {
          console.log("📌 Blog Keywords (raw):", blog.keyword);
          const parsedKeywords = blog.keyword
            .split(",")
            .map((kw) => kw.trim())
            .filter((kw) => kw !== "")
            .map((kw) => ({
              keyword: kw,
              id: Date.now() + Math.random(),
            }));
  
          setKeywords(parsedKeywords);
        } else {
          console.log("⚠️ No keywords found in blog");
        }
        if (blog.blocks && Array.isArray(blog.blocks)) {
          setBlocks(blog.blocks); 
          console.log("Blog Blocks:", blog.blocks);
        }
  
        if (authors.length > 0) {
          const matchingAuthor = authors.find(
            (author) =>
              author.label.trim().toLowerCase() ===
              blog.author_name.trim().toLowerCase()
          ); if (matchingAuthor) {
            setSelectedAuthor(matchingAuthor);
          } else {
            console.log("No matching author found");
          }
        } else {
         
        }
      } else {
        console.error("Failed to fetch blogs:", data.msg);
      }
    } catch (error) {
      console.error("Error fetching blog:", error);
    } finally {
      setLoading(false);
    }
  };

  const {
    siteid,
    setTransactionLoaderState,
    siteurl,
    setURL,
    siteObj,
    Productname,
    user,
  } = useContext(GlobalContext);

  const [Authormodal, setAuthormodal] = useState(false);
  const [authors, setAuthors] = useState([]);
  const [selectedAuthor, setSelectedAuthor] = useState(null);
  const [keyword, setKeyword] = useState("");
  const initialKeywords = Editblogid?.post_keywords
    ? Editblogid.post_keywords
        .split(",")
        .map((kw) => kw.trim())
        .filter((kw) => kw !== "")
        .map((kw) => ({
          keyword: kw,
          id: Date.now() + Math.random(),
        }))
    : [];
  const [keywords, setKeywords] = useState(initialKeywords);
  const [suggestedKeywords, setSuggestedKeywords] = useState([]);
  const [filteredSuggestions, setFilteredSuggestions] = useState([]);
  const [categories, setCategories] = useState([]);
  const [subcategories, setSubcategories] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [selectedSubcategory, setSelectedSubcategory] = useState(null);

  const [formState, setFormState] = useState({
    title: "",
    excerpt: "",
    imageUrl: "",
    slug: "",
    imgtitle: "",
    alt: "",
    imgdesc: "",
  });
  useEffect(() => {
    const Editblogid = JSON.parse(sessionStorage.getItem("Editblogid"));
    console.log(Editblogid.slug);
    if (Editblogid) {
      setFormState({
        title: Editblogid.post_title || "",
        slug: Editblogid.post_slug || "",
        excerpt: Editblogid.post_excerpt || "",
        featuredImage: Editblogid.post_featured_image || "",
        imgtitle: Editblogid.post_featured_image_title || "",
        alt: Editblogid.post_featured_image_alt || "",
        imgdesc: Editblogid.post_featured_image_desc || "",
      });
    }
  }, []);
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormState((prevState) => ({
      ...prevState,
      [name]: value,
      slug:
        name === "title" && !prevState.slugEdited
          ? generateSlug(value)
          : prevState.slug,
    }));
  };
  const handleSlugChange = (e) => {
    const { value } = e.target;
    setFormState((prevState) => ({
      ...prevState,
      slug: value,
      slugEdited: true,
    }));
  };
  const generateSlug = (title) => {
    return title
      .toLowerCase()
      .trim()
      .replace(/[^a-z0-9\s-]/g, "")
      .replace(/\s+/g, "-");
  };
  const handlefeatureImageUpload = async (event) => {
    const files = Array.from(event.target.files);
    for (const file of files) {
      const reader = new FileReader();
      reader.onloadend = async () => {
        const binaryData = reader.result;
        const filename1 = file.name;
        setLoading(true);
        try {
          const response = await fetch(
            `${siteurl}/api/upload.php?filename=${encodeURIComponent(
              filename1
            )}`,
            {
              method: "POST",
              body: binaryData,
              headers: {
                "Content-Type": "application/octet-stream",
              },
            }
          );

          const result = await response.json();

          if (result.status === "success") {
            const imageUrl = result.file_url;
            setFormState((prevState) => ({
              ...prevState,
              featuredImage: imageUrl, // Update the featured image URL
            }));

            swal({
              title: "Success!",
              text: `File uploaded successfully. URL: ${imageUrl}`,
              icon: "success",
              button: "OK",
            });
            setLoading(false);
          } else {
            swal({
              title: "Error!",
              text: result.message,
              icon: "error",
              button: "OK",
            });
          }
        } catch (error) {
          setLoading(false);
          swal({
            title: "Error!",
            text: `Upload failed: ${error.message}`,
            icon: "error",
            button: "OK",
          });
        }
      };

      reader.readAsArrayBuffer(file);
    }
  };

  const Publish = async () => {
    setLoading(true);
    try {
      if (!selectedAuthor) {
        swal("Error", "Please select an author", "error");
        return;
      }
      if (!selectedCategory || !selectedSubcategory) {
        swal("Error", "Please select a category and subcategory", "error");
        return;
      }
  
      const {
        title,
        excerpt,
        imageUrl,
        slug,
        imgtitle,
        alt,
        imgdesc
      } = formState;
  
      const keywordString = keywords.map((kw) => kw.keyword).join(",");
  
      // Build block_data array
      const block_data = blocks.map((block, index) => ({
        block_type: block.block_type || "p",
        block_content: block.block_content || "",
        block_style: block.block_style || "",
        block_image: block.block_image || "",
        block_order: index.toString(),
        block_image_alt: block.block_image_alt || "",
        block_image_desc: block.block_image_desc || "",
        block_image_title: block.block_image_title || ""
      }));
  
      const raw = JSON.stringify({
        temp_post_id: Editblogid?.tempid || "", // From Edit blog state
        user_id: user.user_id , // Replace with actual user ID from auth
        title,
        excerpt,
        slug,
        keywords: keywordString,
        tags: "", // You can fetch tags from UI if applicable
        webid: siteid , // Set actual website/project ID
        authorid: selectedAuthor.value,
        created_at: new Date().toISOString(),
        updated_at: new Date().toISOString(),
        image_url: imageUrl || formState.featuredImage,
        image_title: imgtitle,
        image_desc: imgdesc,
        description: editorRef.current.innerHTML,
        categoryid: selectedCategory.value,
        sub_categoryid: selectedSubcategory.value,
        block_data
      });
  
      const requestOptions = {
        method: "POST",
        headers: {
          Authorization: `Basic ${base64Credentials}`,
          "Content-Type": "application/json",
        },
        body: raw,
        redirect: "follow"
      };
  
      const res = await fetch(`${BASE_URL_API_BLOG}/InsertTempBlogs`, requestOptions);
      const data = await res.json();
  
      if (data.status === "0") {
        const blogResult = data.result[0].result;
        const blogMessage = data.result[0].message;
  
        swal({
          title: "Success!",
          text: `${data.msg} - ${blogMessage}`,
          icon: "success",
          button: "OK"
        });
        setLoading(false);
      } else {
        swal("Error", data.msg, "error");
      }
    } catch (error) {
      setLoading(false);
      swal({
        title: "Error!",
        text: `Publish failed: ${error.message}`,
        icon: "error",
        button: "OK"
      });
    }
  };
  
  const SaveEditedBlog = async () => {
    setLoading(true);
    try {
      if (!selectedAuthor) {
        swal("Error", "Please select an author", "error");
        return;
      }
      if (!selectedCategory || !selectedSubcategory) {
        swal("Error", "Please select a category and subcategory", "error");
        return;
      }

      const { title, excerpt, imageUrl, slug, imgtitle, alt, imgdesc } =
        formState;
      const keywordString = keywords.map((kw) => kw.keyword).join(",");
      const htmlContent = editorRef.current.innerHTML;
      setSubmittedContent(htmlContent);
      console.log("Submitted HTML Content with Style:\n", htmlContent);

      const raw = JSON.stringify({
        p_temp_post_id: Editblogid?.post_tempid,
        p_post_title: title,
        p_post_content: htmlContent,
        p_post_excerpt: excerpt,
        p_post_author: selectedAuthor.value,
        p_post_featured_image: imageUrl || formState.featuredImage,
        p_status: "Draft",
        p_product_name: Productname,
        p_post_keywords: keywordString,
        p_post_featured_image_title: imgtitle,
        p_post_featured_image_desc: imgdesc,
        p_post_featured_image_alt: alt,
        p_post_category: selectedCategory.value,
        p_post_subcategory: selectedSubcategory.value,
        p_slug: slug,
      });

      const requestOptions = {
        method: "POST",
        headers: {
          Authorization: `Basic ${base64Credentials}`,
          "Content-Type": "application/json",
        },
        body: raw,
        redirect: "follow",
      };

      const res = await fetch(
        `${BASE_URL_API_BLOG}/SaveEditedBlog`,
        requestOptions
      );
      const data = await res.json();

      if (data.status === "0") {
        const blogResult = data.result[0].result;
        const blogMessage = data.result[0].message;

        swal({
          title: "Success!",
          text: `${data.msg} - ${blogMessage}`,
          icon: "success",
          button: "OK",
        });
        setLoading(false);
      } else {
        swal("Error", data.msg, "error");
      }
    } catch (error) {}
  };
  const GetAuthorsBlog = async () => {
    setTransactionLoaderState(true);
    setLoading(true);
    try {
      const myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");

      const requestOptions = {
        method: "POST",
        headers: {
          Authorization: `Basic ${base64Credentials}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          slug: "all",
        }),
        redirect: "follow",
      };

      const res = await fetch(
        `${BASE_URL_API_BLOG}/GetAuthorsBlog`,
        requestOptions
      );
      const data = await res.json();
      console.log("GetAuthorsBlog response:", data);

      if (data.status === "0") {
        const mappedAuthors = data.data.map((author) => ({
          label: `${author.fullname}`,
          value: author.id,
        }));

        setAuthors(mappedAuthors);
        const matchingAuthor = mappedAuthors.find(
          (author) => author.label === Editblogid.post_author
        );
        if (matchingAuthor) {
          setSelectedAuthor(matchingAuthor);
        }
        setLoading(false);
      } else {
        console.error("Failed to fetch authors:", data.msg);
      }
    } catch (error) {
      console.log("Error fetching authors:", error);
    } finally {
      setTransactionLoaderState(false);
    }
  };

  useEffect(() => {
    GetAuthorsBlog();
  }, []);

  useEffect(() => {
    if (authors.length > 0) {
      GetProductBlogBySlug();
    }
  }, [authors]);

  const handleAuthorChange = (selected) => {
    if (selected.value === "addAuthor") {
      setAuthormodal(true);
    } else {
      setSelectedAuthor(selected);
    }
  };
  const getSuggestedKeywords = async () => {
    setTransactionLoaderState(true);
    try {
      const myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");

      const requestOptions = {
        method: "POST",
        headers: {
          Authorization: `Basic ${base64Credentials}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({}),
        redirect: "follow",
      };
      const res = await fetch(
        `${BASE_URL_API_BLOG}/GetBlogKeywords`,
        requestOptions
      );
      const data = await res.json();
      console.log("Suggested Keywords response:", data);

      if (data.status === "0") {
        setSuggestedKeywords(data.data);
      } else {
        console.error("Failed to fetch suggested keywords:", data.msg);
      }
    } catch (error) {
      console.log("Error fetching suggested keywords:", error);
    } finally {
      setTransactionLoaderState(false);
    }
  };
  useEffect(() => {
    getSuggestedKeywords();
  }, []);
  useEffect(() => {
    if (keyword) {
      const filtered = suggestedKeywords.filter((suggestion) =>
        suggestion.keyword.toLowerCase().includes(keyword.toLowerCase())
      );
      setFilteredSuggestions(filtered);
    } else {
      setFilteredSuggestions([]);
    }
  }, [keyword, suggestedKeywords]);
  const handleSelectSuggested = (suggestedKeyword) => {
    setKeywords((prev) => [
      ...prev,
      { id: suggestedKeyword.id, keyword: suggestedKeyword.keyword },
    ]);
    setKeyword("");
  };
  const handleAddKeyword = (kw = keyword) => {
    if (kw) {
      const newKeywords = kw
        .split(",")
        .map((kw) => kw.trim())
        .filter(
          (kw) => kw && !keywords.some((existing) => existing.keyword === kw)
        );

      setKeywords([
        ...keywords,
        ...newKeywords.map((kw) => ({
          keyword: kw,
          id: Date.now() + Math.random(),
        })),
      ]);

      newKeywords.forEach((newKw) => {
        Insertkeywords(newKw);
      });

      setKeyword("");
    }
  };
  const handleKeywordPress = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      handleAddKeyword();
    }
  };
  const handleRemoveKeyword = (id) => {
    setKeywords((prevKeywords) => prevKeywords.filter((kw) => kw.id !== id));
  };
  const Insertkeywords = async (kw) => {
    try {
      const raw = JSON.stringify({
        tempid: Editblogid.post_id,
        keyword: kw,
      });

      const requestOptions = {
        method: "POST",
        headers: {
          Authorization: `Basic ${base64Credentials}`,
          "Content-Type": "application/json",
        },
        body: raw,
        redirect: "follow",
      };

      const res = await fetch(
        `${BASE_URL_API_BLOG}/InsertKeywordsBlog`,
        requestOptions
      );
      const data = await res.json();

      if (data.status === "0") {
        const result = data.result[0];
        if (result && result.result === "Y") {
          console.log(result.message);
        } else {
          console.log("Unexpected result format");
        }
      } else {
        console.log(data.msg);
      }
    } catch (error) {
      console.error("Error during submission:", error);
    }
  };
  const fetchCategories = async () => {
    setTransactionLoaderState(true);
    setLoading(true);
    try {
      const myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");

      const requestOptions = {
        method: "POST",
        headers: {
          Authorization: `Basic ${base64Credentials}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          type:"0"
        }),
        redirect: "follow",
      };

      const res = await fetch(
        `${BASE_URL_API_BLOG}/GetBlogCategories`,
        requestOptions
      );
      const data = await res.json();
      console.log("Geteditloadblog response:", data);

      if (data.status === "0") {
        const mappedCategories = data.data.map((category) => ({
          label: category.category_name,
          value: category.id,
        }));

        setCategories(mappedCategories);

        // 👇 Match and set the prefilled category from Editblogid
        const matchingCategory = mappedCategories.find(
          (category) => category.label === Editblogid.post_category
        );

        if (matchingCategory) {
          setSelectedCategory(matchingCategory);

          // 👇 Manually call fetchSubcategories with matched category id
          fetchSubcategories(matchingCategory.value);
        }
        setLoading(false);
      } else {
        console.error("Failed to fetch categories:", data.msg);
      }
    } catch (error) {
      console.log("error", error);
    } finally {
      setLoading(false);
      setTransactionLoaderState(false);
    }
  };
  const fetchSubcategories = async (categoryId) => {
    setTransactionLoaderState(true);
    setLoading(true);
    try {
      const myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");

      const requestOptions = {
        method: "POST",
        headers: myHeaders,
        headers: {
          Authorization: `Basic ${base64Credentials}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ categoryid: categoryId }),
        redirect: "follow",
      };

      const res = await fetch(
        `${BASE_URL_API_BLOG}/GetBlogSubCategories`,
        requestOptions
      );
      const data = await res.json();
      console.log("Geteditloadblog response:", data);

      if (data.status === "0") {
        const mappedSubcategories = data.data.map((subcategory) => ({
          label: subcategory.sub_category,
          value: subcategory.id,
        }));

        setSubcategories(mappedSubcategories);

        // 👇 Find and set prefilled subcategory if available
        const matchingSubcategory = mappedSubcategories.find(
          (item) => item.label === Editblogid?.post_subcategory
        );

        if (matchingSubcategory) {
          setSelectedSubcategory(matchingSubcategory);
        }
      } else {
        console.error("Failed to fetch blogs:", data.msg);
      }
    } catch (error) {
      console.log("error", error);
    } finally {
      setLoading(false);
      setTransactionLoaderState(false);
    }
  };

  const handleCategoryChange = (selectedOption) => {
    setSelectedCategory(selectedOption);
    setSubcategories([]);
    setSelectedSubcategory(null);
    fetchSubcategories(selectedOption.value);
  };
  const handleSubcategoryChange = (selectedOption) => {
    setSelectedSubcategory(selectedOption);
  };
  useEffect(() => {
    fetchCategories();
  }, []);
  const iframeRef = useRef(null);
  const sendContentToEditor = (content) => {
    if (iframeRef.current) {
      iframeRef.current.contentWindow.postMessage(
        { type: "setContent", content },
        "*"
      );
    }
  };

  useEffect(() => {
    if (Editblogid?.post_content) {
      sendContentToEditor(Editblogid.post_content);
    }
  }, [Editblogid]);

  return (
    <div
      className="m-3"
      style={{
        height: "85vh",
        overflowY: "auto",
        scrollbarWidth: "none",
        msOverflowStyle: "none",
      }}
    >
      <style>
        {`
        .hide-scrollbar::-webkit-scrollbar {
          display: none;
        }
      `}
      </style>
      <Authorblogmodal
        Authormodal={Authormodal}
        setAuthormodal={setAuthormodal}
        GetAuthorsBlog={GetAuthorsBlog}
      />

      <div className="row mt-0 pt-0 pb-0">
        <div className="col">
          <h5>Edit Blogs</h5>
        </div>
        <div className="col d-flex justify-content-end">
          <Button
            variant="info"
            size="sm"
            type="submit"
            style={{ height: "2rem" }}
            onClick={() => SaveEditedBlog()}
          >
            Save
          </Button>{" "}
          <Button
            style={{ background: "#fff", border: "none" }}
            size="sm"
            type="submit"
          ></Button>
          <Button
            variant="info"
            size="sm"
            type="submit"
            style={{ height: "2rem" }}
            onClick={() => Publish()}
          >
            Publish
          </Button>{" "}
          <Button
            style={{ background: "#fff", border: "none" }}
            size="sm"
            type="submit"
          ></Button>
          <Link to="/blog/Allblog">
            <Button size="sm" variant="info">
              Back
            </Button>
          </Link>
        </div>
      </div>

      <Form className="p-2">
        <Form.Group className="" controlId="formTitle">
          <Form.Label className="mb-0 mr-2">Title</Form.Label>
          <Form.Control
            type="text"
            placeholder="Enter title"
            name="title"
            value={formState.title}
            onChange={handleChange}
          />{" "}
        </Form.Group>
        <Form.Group className="" controlId="formslug">
          <Form.Label className="mb-0 mr-2">slug</Form.Label>
          <Form.Control
            as="textarea"
            rows={1}
            placeholder="Add slug"
            name="slug"
            value={formState.slug}
            onChange={handleSlugChange}
          />{" "}
        </Form.Group>
        <Form.Group className="" controlId="formExcerpt">
          <Form.Label className="mb-0 mr-2">Excerpt</Form.Label>
          <Form.Control
            as="textarea"
            rows={1}
            placeholder="Add excerpt"
            name="excerpt"
            value={formState.excerpt}
            onChange={handleChange}
          />{" "}
        </Form.Group>
        <div className="row">
          <Form.Group className="col-md-3 col-6 " controlId="formImage">
            <Form.Label className="mb-0 mr-2">Feature image</Form.Label>
            <div className="d-flex align-items-center">
              {formState.featuredImage && (
                <img
                  src={formState.featuredImage}
                  alt="Featured"
                  style={{
                    width: "3rem",
                    height: "3rem",
                    borderRadius: "50%",
                    objectFit: "cover",
                    marginRight: "1rem",
                  }}
                />
              )}
              <Form.Control
                type="file"
                accept="image/*"
                onChange={handlefeatureImageUpload}
                className="flex-grow-1"
                style={{ maxWidth: "200px" }}
              />
            </div>
          </Form.Group>

          <Form.Group className="col-md-3 col-6" controlId="formExcerpt">
            <Form.Label className="mb-0 mr-2">Feature Image Title</Form.Label>
            <Form.Control
              type="text"
              placeholder="Add Title"
              name="imgtitle"
              value={formState.imgtitle}
              onChange={handleChange}
            />{" "}
          </Form.Group>
          <Form.Group className="col-md-3 col-6" controlId="formExcerpt">
            <Form.Label className="mb-0 mr-2"> Feature Image Alt</Form.Label>
            <Form.Control
              type="text"
              placeholder="Add Alt"
              name="alt"
              value={formState.alt}
              onChange={handleChange}
            />{" "}
          </Form.Group>
          <Form.Group className="col-md-3 col-6" controlId="formExcerpt">
            <Form.Label className="mb-0 mr-2">
              Feature Image Description
            </Form.Label>
            <Form.Control
              type="text"
              placeholder="Add Description"
              name="imgdesc"
              value={formState.imgdesc}
              onChange={handleChange}
            />{" "}
          </Form.Group>
        </div>
      </Form>
      <div className="row">
        <div className=" col-md-9 col-12 px-md-2">
          <div>
            <div>
              <Editblogeditor editorRef={editorRef} blocks={blocks}/>
            </div>
          </div>
        </div>
        <div className="col-md-3 p-0 col-12">
          <div className="card mt-2 p-2 mb-2">
            <h6 className="text-center">
              <strong>Author</strong>{" "}
            </h6>
            <Select
              options={[
                { label: "Add Author", value: "addAuthor" },
                ...authors,
              ]}
              value={selectedAuthor}
              onChange={handleAuthorChange}
              styles={getCustomStyles()}
            />
          </div>
          <div className="card p-2 mb-2">
            <h6 className="text-center">
              <strong>Category</strong>{" "}
            </h6>
            <Select
              value={selectedCategory}
              onChange={handleCategoryChange}
              options={categories}
              placeholder=" Category"
              styles={getCustomStyles()}
            />

            {/* {selectedCategory && ( */}
            <>
              <h6 className="mt-3">Select Subcategory</h6>
              <Select
                value={selectedSubcategory}
                onChange={handleSubcategoryChange}
                options={subcategories}
                placeholder="Select Subcategory"
                styles={getCustomStyles()}
              />
            </>
            {/* )} */}
          </div>
          <div className="card p-2 mb-2">
            <h6 className="text-center">
              <strong>Keywords</strong>{" "}
            </h6>
            <Form inline className="">
              <Form.Control
                type="text"
                value={keyword}
                onChange={(e) => {
                  setKeyword(e.target.value);
                }}
                placeholder="Enter keywords separated by commas"
                className="mr-2"
                style={{ width: "100%" }}
                onKeyPress={handleKeywordPress} // Call function on Enter key press
              />
            </Form>
            {filteredSuggestions.length > 0 && (
              <div className="suggested-keywords mt-2">
                <strong>Suggested Keywords:</strong>
                <div className="d-flex flex-wrap">
                  {filteredSuggestions.map((suggested) => (
                    <div
                      key={suggested.id}
                      className="d-flex align-items-center m-1 p-2 border rounded bg-light"
                      style={{ cursor: "pointer" }}
                      onClick={() => handleSelectSuggested(suggested)}
                    >
                      {suggested.keyword}
                    </div>
                  ))}
                </div>
              </div>
            )}
            <Tab.Container id="keyword-tabs" defaultActiveKey="keywords">
              <Tab.Content>
                <Tab.Pane eventKey="keywords">
                  <div className="d-flex flex-wrap">
                    {keywords.length > 0 ? (
                      keywords.map((kw) => (
                        <div
                          key={kw.id}
                          className="d-flex align-items-center m-1 p-2 border rounded bg-light"
                          style={{
                            position: "relative",
                            margin: "5px",
                            padding: "5px 10px",
                          }}
                        >
                          {kw.keyword} &nbsp; &nbsp;
                          <AiOutlineClose
                            style={{
                              position: "absolute",
                              right: "5px",
                              top: "50%",
                              transform: "translateY(-50%)",
                              cursor: "pointer",
                            }}
                            onClick={() => handleRemoveKeyword(kw.id)}
                          />
                        </div>
                      ))
                    ) : (
                      <div className="text-center mt-4">No keywords found</div>
                    )}
                  </div>
                </Tab.Pane>
              </Tab.Content>
            </Tab.Container>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Editblogs;
